import type {PayloadAction} from '@reduxjs/toolkit';
import {createSlice} from '@reduxjs/toolkit';
import type {DesignerAttributionInfo} from '@Components/poster-editor/components/poster-editing-side-panel/components/designer-attribution/designer-attribution.types';
import {fetchDesignerAttribution} from '@Components/poster-editor/components/poster-editing-side-panel/components/designer-attribution/designer-attribution.thunk';
import type {RootState} from '@/store';

interface StateProps {
  byTemplateId: Record<string, DesignerAttributionInfo>;
  pendingTemplateIds: Record<string, boolean>;
}

const initialState: StateProps = {
  byTemplateId: {},
  pendingTemplateIds: {},
};

interface SeedDesignerAttributionPayload {
  templateId: string;
  info: DesignerAttributionInfo;
}

const designerAttributionSlice = createSlice({
  name: 'designerAttribution',
  initialState,
  reducers: {
    seedDesignerAttribution: (state, action: PayloadAction<SeedDesignerAttributionPayload>) => {
      state.byTemplateId[action.payload.templateId] = action.payload.info;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDesignerAttribution.pending, (state, action) => {
        state.pendingTemplateIds[action.meta.arg] = true;
      })
      .addCase(fetchDesignerAttribution.fulfilled, (state, action) => {
        state.byTemplateId[action.payload.templateId] = action.payload.info;
        // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete state.pendingTemplateIds[action.payload.templateId];
      })
      .addCase(fetchDesignerAttribution.rejected, (state, action) => {
        // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete state.pendingTemplateIds[action.meta.arg];
      });
  },
});

export const {seedDesignerAttribution} = designerAttributionSlice.actions;
export const designerAttributionReducer = designerAttributionSlice.reducer;

export const getDesignerAttributionByTemplateId = (state: RootState, templateId: string | undefined): DesignerAttributionInfo | undefined => {
  if (!templateId) {
    return undefined;
  }
  return state.designerAttribution.byTemplateId[templateId];
};
